// extracted by mini-css-extract-plugin
module.exports = {"sheetDisclaimer":"DisclaimerMessage_sheetDisclaimer__iCZ2g"};